import { Box, Divider, Grid } from '@mui/material'

import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { colors } from 'constants/theme'

import { APPOINTMENT_SHARING, CALCULATE_ADVANCE, CODE_OPERATIVE } from 'constants/status'
import SelectInput from 'new-components/inputs/select-input'
import { DEFAULT_DF_CON, DEFAULT_DF_REPORT, PATIENT_CODE, TIME_APPOINTMENT, TREATMENT } from './form-branch'
import OpShowAppointmentSharing from './preview-setting/appointment-sharing'
import OpAppointmentTime from './preview-setting/appointment-time'
import OpCalAdvance from './preview-setting/cal-advance'
import OpShowOperativeCode from './preview-setting/code_operative'
import OpModelDF from './preview-setting/model-DF'
import OpDF from './preview-setting/preview-DF'
import OpShowPatient from './preview-setting/show-patient'
import OpTreatment from './preview-setting/treatment'


type FormBranchSettingProps = {
    showPatient: string
    setShowPatient: (value: PATIENT_CODE.CN | PATIENT_CODE.PT | PATIENT_CODE.SN) => void
    appointmentTime: string
    setAppointmentTime: (value: TIME_APPOINTMENT.CLINIC | TIME_APPOINTMENT.SCHEDULE) => void
    treatment: string
    setTreatment: (value: TREATMENT.TYPE | TREATMENT.TX) => void
    preveiwDf: string
    setPreveiwDf: (value: DEFAULT_DF_REPORT.PAY | DEFAULT_DF_REPORT.OP) => void
    modelDf: string
    setModelDf: (value: DEFAULT_DF_CON.PAY_1 | DEFAULT_DF_CON.PAY_2 | DEFAULT_DF_CON.PAY_3 | DEFAULT_DF_CON.PAY_4 | DEFAULT_DF_CON.PAY_5) => void
    calAdvance: string
    setCalAdvance: (value: CALCULATE_ADVANCE.INCREASE | CALCULATE_ADVANCE.DECREASE) => void
    showOperativeCode: string
    setShowOperativeCode: (value: CODE_OPERATIVE.NOT_DISPLAYED | CODE_OPERATIVE.SHOW) => void
    showAppointmentSharing: string
    setShowAppointmentSharing: (value: APPOINTMENT_SHARING.NOT_DISPLAYED | APPOINTMENT_SHARING.SHOW) => void
}

const FormBranchSetting = (props: FormBranchSettingProps) => {
    const { t } = useTranslation()

    const { showPatient, setShowPatient, appointmentTime, setAppointmentTime, preveiwDf, setPreveiwDf, modelDf, setModelDf, calAdvance, setCalAdvance, treatment, setTreatment, showOperativeCode, setShowOperativeCode, showAppointmentSharing, setShowAppointmentSharing } = props

    const [openSelectInput, setOpenSelectInput] = useState(false)
    const [previewComponent, setPreviewComponent] = useState<ReactNode>(<></>)

    const [selectInput, setSelectInput] = useState('optionShowPatient')

    const optionShowPatient = OpShowPatient()
    const optionAppointmentTime = OpAppointmentTime()
    const optionTreatment = OpTreatment()
    const optionDF = OpDF()
    const optionModelDF = OpModelDF()
    const optionCalAdvance = OpCalAdvance()
    const optionShowOperativeCode = OpShowOperativeCode()
    const optionShowAppointmentSharing = OpShowAppointmentSharing()

    const handleChangePreviewComponent = (op: any[], data: any) => {
        const newComponent = op.find((item) => item.value === data)?.component || <>Unknow</>
        setPreviewComponent(newComponent)
        setOpenSelectInput(false)
    }

    const handlePreviewInfo = (pre: string) => {
        setSelectInput(pre)
        if (openSelectInput) {
            setOpenSelectInput(false)
            return
        }
        switch (pre) {
            case 'optionShowPatient':
                handleChangePreviewComponent(optionShowPatient, showPatient)
                break;
            case 'optionAppointmentTime':
                handleChangePreviewComponent(optionAppointmentTime, appointmentTime)
                break;
            case 'optionTreatment':
                handleChangePreviewComponent(optionTreatment, treatment)
                break;
            case 'optionShowAppointmentSharing':
                handleChangePreviewComponent(optionShowAppointmentSharing, showAppointmentSharing)
                break;
            case 'optionDF':
                handleChangePreviewComponent(optionDF, preveiwDf)
                break;
            case 'optionModelDF':
                handleChangePreviewComponent(optionModelDF, modelDf)
                break;
            case 'optionShowOperativeCode':
                handleChangePreviewComponent(optionShowOperativeCode, showOperativeCode)
                break;
            default:
                handleChangePreviewComponent(optionCalAdvance, calAdvance)
        }

    }

    useEffect(() => {
        handlePreviewInfo('optionShowPatient')
    }, [])

    return (
        <Box>
            <Grid container className="mt-3" display='flex'>
                <Grid container item lg={6} xs={12}
                    maxWidth={{ lg: '670px !important', xs: '100%' }}
                    width={{ lg: '50%', xs: '100%' }}
                    paddingRight={{ lg: '12px', xs: '0' }}
                    height={'fit-content'}
                    maxHeight={'calc(100vh - 280px)'}
                    sx={{ overflowY: 'auto' }}
                >

                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowPatient')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowPatient' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowPatient' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.SHOWPATIENT')}{t('BRANCH.TAB.SENTTING.SYSTEM')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowPatient(data)
                                    handleChangePreviewComponent(optionShowPatient, data)
                                }}
                                options={optionShowPatient}
                                value={showPatient.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionAppointmentTime')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionAppointmentTime' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionAppointmentTime' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.INPUT.APPOINTMENT_TIME')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setAppointmentTime(data)
                                    handleChangePreviewComponent(optionAppointmentTime, data)
                                }}
                                options={optionAppointmentTime}
                                value={appointmentTime.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionTreatment')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionTreatment' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionTreatment' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.INPUT.APPT_SERVICE')}
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setTreatment(data)
                                    handleChangePreviewComponent(optionTreatment, data)
                                }}
                                options={optionTreatment}
                                value={treatment.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowAppointmentSharing')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowAppointmentSharing' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowAppointmentSharing' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.APPOINTMENT_SHARING')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowAppointmentSharing(data)
                                    handleChangePreviewComponent(optionShowAppointmentSharing, data)
                                }}
                                options={optionShowAppointmentSharing}
                                value={showAppointmentSharing}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionDF')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionDF' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionDF' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.DF_TREAMENT')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setPreveiwDf(data)
                                    handleChangePreviewComponent(optionDF, data)
                                }}
                                options={optionDF}
                                value={preveiwDf.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    {/* ซ่อนตัวเลือก "รูปแบบการคิด DF" — TDH ไม่ได้ใช้การคำนวณจากส่วนนี้ */}
                    {/* <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionModelDF')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionModelDF' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionModelDF' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.CONDITION_REPORT_DF')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setModelDf(data)
                                    handleChangePreviewComponent(optionModelDF, data)
                                }}
                                options={optionModelDF}
                                value={modelDf.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} /> */}
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionCalAdvance')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionCalAdvance' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionCalAdvance' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.CAL_ADVANCE')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setCalAdvance(data)
                                    handleChangePreviewComponent(optionCalAdvance, data)
                                }}
                                options={optionCalAdvance}
                                value={calAdvance.toString()}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    <Grid container item padding='8px 0' onClick={() => handlePreviewInfo('optionShowOperativeCode')}>
                        <Grid item sm={6} alignContent="center">
                            <Box
                                bgcolor={selectInput === 'optionShowOperativeCode' ? colors.themeSecondColor06 : ''}
                                padding="8px 16px 8px 16px"
                                borderRadius="32px"
                                display="inline-block"
                            >
                                <Box color={selectInput === 'optionShowOperativeCode' ? colors.themeSecondColor : ''}>
                                    {t('BRANCH.TAB.SENTTING.CODE_OPERATIVE')}
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <SelectInput
                                onOpen={() => setOpenSelectInput(true)}
                                label=''
                                onChange={(e) => {
                                    const data = e.target.value
                                    setShowOperativeCode(data)
                                    handleChangePreviewComponent(optionShowOperativeCode, data)
                                }}
                                options={optionShowOperativeCode}
                                value={showOperativeCode}
                            />
                        </Grid>
                    </Grid>
                    <Divider sx={{ width: '100%', my: 3, bgcolor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />

                </Grid>
                <Grid lg xs={0} height={'fit-content'}
                    maxHeight={'calc(100vh - 300px)'}
                    sx={{ overflowY: 'auto' }}>
                    <Box width='100%' height='100%' padding='16px' bgcolor={'#F7F8F8'}>
                        <FormBranchSettingPreview component={previewComponent} />
                    </Box>
                </Grid>
            </Grid >
        </Box>
    )
}

export default FormBranchSetting

interface FormSettingPreviewProps {
    component: ReactNode
}
const FormBranchSettingPreview = (props: FormSettingPreviewProps) => {
    const { component } = props
    return (
        <Box>
            {component}
        </Box>
    )
}